import { Stack, Title, Text } from "@mantine/core";

export const SectionTitleWithExp = ({
	title,
	exp,
	isMobile,
	size = "default",
}) => {
	return (
		<Stack gap={0} pl={3}>
			<Title
				order={size === "big" ? (isMobile ? 3 : 2) : isMobile ? 4 : 3}
				fw={700}
				style={{ whiteSpace: "pre-line" }}
			>
				{title}
			</Title>
			{exp && <Text size="lg">{exp}</Text>}
		</Stack>
	);
};
